import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function QrLabel({ rework }) {
  const url = `${window.location.origin}/rework/${rework.id}?scan=1`;

  const print = () => {
    const w = window.open("", "_blank", "width=420,height=520");
    if (!w) return;
    const doc = w.document;
    doc.title = `Rework label ${rework.job_number}`;
    const style = doc.createElement("style");
    style.textContent = "body{font-family:Arial,sans-serif;text-align:center;padding:24px}h1{font-size:28px;margin:8px 0 0}h2{font-size:18px;color:#444;margin:4px 0 12px}p{font-size:12px;color:#666}";
    doc.head.appendChild(style);
    const qrNode = document.getElementById(`qr-${rework.id}`);
    if (qrNode) doc.body.appendChild(doc.importNode(qrNode, true));
    const add = (tag, text) => {
      const el = doc.createElement(tag);
      el.textContent = text;
      doc.body.appendChild(el);
    };
    add("h1", rework.job_number);
    add("h2", rework.part_number);
    add("p", `${rework.request_type} · ${rework.rework_reason}`);
    add("p", "Scan to update status in MISCO Rework Hub");
    w.focus();
    w.print();
  };

  return (
    <div className="border border-[#e6e5df] bg-white rounded-sm p-6" data-testid="qr-label">
      <div className="text-[10px] uppercase tracking-widest text-[#6b6a68] font-mono mb-3">Rack label · QR</div>
      <div className="flex items-center gap-5">
        <div className="bg-white p-2 border border-[#e6e5df] rounded-sm">
          <QRCodeSVG id={`qr-${rework.id}`} value={url} size={112} level="M" fgColor="#232826" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="mono text-lg text-[#232826]">{rework.job_number}</div>
          <div className="mono text-sm text-[#424e43]">{rework.part_number}</div>
          <p className="text-xs text-[#6b6a68] mt-2">Stick this on the part. Scanning at any station opens the one-tap stage update.</p>
          <Button onClick={print} variant="secondary" size="sm" data-testid="qr-print"
            className="mt-3 rounded-sm bg-[#e6e5df] hover:bg-[#cfcfc9] text-[#232826] border border-[#cfcfc9] uppercase text-[11px] tracking-widest">
            <Printer size={13} className="mr-2" /> Print label
          </Button>
        </div>
      </div>
    </div>
  );
}
